<template>
  <div>
    <select
      name="provinceSelector"
      @change="getCityList()"
      v-model="provinceId"
    >
      <option
        v-for="(item, index) in provinceList"
        :key="index"
        v-text="item.cityName"
        :value="item.cityId"
      ></option>
    </select>
    <select name="citySelector" @change="getTownList()" v-model="cityId">
      <option
        v-for="(item, index) in cityList"
        :key="index"
        v-text="item.cityName"
        :value="item.cityId"
      ></option>
    </select>
    <select name="townSelector" v-model="townId">
      <option
        v-for="(item, index) in townList"
        :key="index"
        v-text="item.cityName"
        :value="item.cityId"
      ></option>
    </select>
  </div>
</template>
<script>
import { getCity } from '@/requests/module'
export default {
  data() {
    return {
      provinceId: '',
      cityId: '',
      townId: '',
      provinceList: [],
      cityList: [],
      townList: [],
      initState: false, //初始化状态
    }
  },
  mounted() {
    this.getProvinceList()
  },
  methods: {
    async init({ grepA, grepB, grepC }) {
      this.initState = true
      this.provinceId = grepA ? grepA : ''
      this.cityId = grepB ? grepB : ''
      this.townId = grepC ? grepC : ''
      await this.getProvinceList()
      await this.getCityList()
      await this.getTownList()
      this.initState = false
    },
    getRes() {
      return this.townId ? this.townId : false
    },
    async getProvinceList() {
      this.provinceList = await this.getList({
        grep: 'A',
      })
    },
    async getCityList() {
      this.cityList = await this.getList({
        grep: 'B',
        pfid: this.provinceId,
      })

      if (!this.initState) {
        this.cityId = ''
        this.townId = ''
        this.townList = []
        this.$forceUpdate()
      }
    },
    async getTownList() {
      this.townList = await this.getList({
        grep: 'C',
        pfid: this.cityId,
      })
      if (!this.initState) {
        this.townId = ''
      }
    },
    getList({ grep, pfid }) {
      return getCity({
        grep,
        pfid,
      })
    },
  },
}
</script>
<style lang="scss" scoped>
@import '_style/msgbox/_comMsg.scss';
select {
  width: 95px;
  height: 30px;
  border: 1px solid #d9dee4;
}
</style>
